// Line sub-text fix (2026-11) — a line's own Client Description (Rate Card field, read
// straight through by the backend with NO fallback to any group text) is frequently the exact
// same sentence copy-pasted across every row in a Presentation Group in the live Rate Card
// data (e.g. "2 DOPs", "Camera & Lens Kit" and "Gimbal" under Cinematography). Never generated,
// never borrowed from another line — this file only decides whether to SHOW a line's own text:
// suppressed when blank, or when it's identical to the text 2+ OTHER lines in its own group
// already share (the "group description"). A genuinely distinct/specific description (e.g.
// Creative Direction, Fixer, Turn Table, Studio Rent) always still shows on its own line.
//
// Used by every agency-facing view that renders per-line description text: AgencyEstimator.jsx
// (which also shows the group description once, under its heading — unchanged), and
// QuoteRequestDetail.jsx / AgencyCostSheet.jsx (which only ever showed it per-line — no new
// group-heading subtitle added to either, this only suppresses the misleading repeats).

/** heading -> the description shared by 2+ lines in that group, or null if every line in the
 * group has its own distinct (or blank) description. */
export function computeGroupDescriptions(lines, getHeading, getDescription) {
  const byHeading = {};
  for (const l of lines) {
    const heading = getHeading(l) || "";
    const desc = (getDescription(l) || "").trim();
    (byHeading[heading] = byHeading[heading] || []).push(desc);
  }
  const groupDesc = {};
  for (const [heading, descs] of Object.entries(byHeading)) {
    const counts = {};
    for (const d of descs) {
      if (d) counts[d] = (counts[d] || 0) + 1;
    }
    let mode = null;
    let modeCount = 0;
    for (const [d, c] of Object.entries(counts)) {
      if (c > modeCount) { mode = d; modeCount = c; }
    }
    groupDesc[heading] = modeCount > 1 ? mode : null;
  }
  return groupDesc;
}

/** This one line's own description, or null if it should show no sub-text at all (blank, or
 * identical to its group's shared description). */
export function effectiveLineDescription(line, getHeading, getDescription, groupDesc) {
  const own = (getDescription(line) || "").trim();
  if (!own) return null;
  const shared = groupDesc[getHeading(line) || ""];
  if (shared && own === shared) return null;
  return own;
}
